import React, { useEffect, useState } from "react";
import location from "../../assets/images/icons/locationIcon.svg";
import {apiBaseUrl, baseUrl} from "../../config";
import Loader from "../loader/Loader";
import { toast } from "react-toastify";

const countryCodeMapping = [
    {"code":"+91", "value":"+91 India"}
]
const stateMapping = [
    {"code":"Noida", "value":"Noida"}
]

const countryMapping = [
    {"code":"India", "value":"India"}
]

function AddressModal({ setRefreshAddresses }) {
  const [selected, setSelected] = useState(1);
  const [addressLine1, setAddressLine1] = useState("");
  const [addressLine2, setAddressLine2] = useState("");
  const [pincodeInfo, setPincodeInfo] = useState("");
  const [countryCode, setCountryCode] = useState("+91");
  const [stateInfo, setStateInfo] = useState("");
  const [countryInfo, setCountryInfo] = useState("India");
  const [districtInfo, setDistrictInfo] = useState("");
  const [emailInfo, setEmailInfo] = useState("");
  const [mobileInfo, setMobileInfo] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false)
    const [defaultAddress, setDefaultAddress] = useState(false);

  // error state
  const [nameError, setNameError] = useState("");
  const [addressLine1Error, setAddressLine1Error] = useState("");
  const [addressLine2Error, setAddressLine2Error] = useState("");
  const [pincodeError, setPincodeError] = useState("");
  const [countryCodeError, setCountryCodeError] = useState("");
  const [stateError, setStateError] = useState("");
  const [countryError, setCountryError] = useState("");
  const [districtError, setDistrictError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [mobileError, setMobileError] = useState("");
  const apiUrl = `${process.env.REACT_APP_BACKEND_URL}customer/add-address`;
  const token = localStorage.getItem("token");
  const cartContext = localStorage.getItem("cartContext");
  const customerId = localStorage.getItem("customerId");

  const validateFields = () => {
    let isValid = true;

    if (!name.trim()) {
      setNameError("Name is required");
      isValid = false;
    } else {
      setNameError("");
    }

    if (!addressLine1.trim()) {
      setAddressLine1Error("Address Line 1 is required");
      isValid = false;
    } else {
        setAddressLine1Error("");
    }
    if (!addressLine1.trim()) {
      setAddressLine2Error("Address Line 2 is required");
      isValid = false;
    } else {
        setAddressLine2Error("");
    }
    if (!countryCode.trim()) {
      setCountryCodeError("Country Code is required");
      isValid = false;
    } else {
        setCountryCodeError("");
    }

    if (!countryInfo.trim()) {
        setCountryError("Country is required");
      isValid = false;
    } else {
        setCountryError("");
    }

    if (!pincodeInfo.trim()) {
      setPincodeError("Pincode is required");
      isValid = false;
    } else if (!/^\d{6}$/.test(pincodeInfo)) {
      setPincodeError("Pincode should be 6 digits");
      isValid = false;
    } else {
      setPincodeError("");
    }

    if (!stateInfo.trim()) {
      setStateError("State is required");
      isValid = false;
    } else {
      setStateError("");
    }

    if (!districtInfo.trim()) {
      setDistrictError("District is required");
      isValid = false;
    } else {
      setDistrictError("");
    }

    if (!emailInfo.trim()) {
      setEmailError("Email is required");
      isValid = false;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailInfo)) {
      setEmailError("Invalid email format");
      isValid = false;
    } else {
      setEmailError("");
    }

    if (!mobileInfo.trim()) {
      setMobileError("Mobile number is required");
      isValid = false;
    } else if (!/^\d{10}$/.test(mobileInfo)) {
      setMobileError("Mobile number should be 10 digits");
      isValid = false;
    } else {
      setMobileError("");
    }

    return isValid;
  };

  useEffect(() => {
    const fetchPincodeDetails = async () => {
      if (pincodeInfo.length === 6) {
        try {
          const response = await fetch(
            `${apiBaseUrl}api/pincodes?pincode=${pincodeInfo}`
          );
          const data = await response.json();

          if (data?.data) {
            setDistrictInfo(data.data.district);
            setStateInfo(data.data.statename);
            setPincodeError("");
          } else {
            setPincodeError(data?.message || "Invalid Pincode");
            setDistrictInfo("");
            setStateInfo("");
          }
        } catch (error) {
          console.error("Pincode API Error:", error);
          setPincodeError("Failed to fetch Pincode details");
          setDistrictInfo("");
          setStateInfo("");
        }
      }
    };

    const timeoutId = setTimeout(() => {
      if (pincodeInfo.length === 6) {
        fetchPincodeDetails();
      }
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [pincodeInfo]);

  const handleSubmit = async () => {
      setLoading(true)
    if (!validateFields()) {
        setLoading(false)
      return;
    }
    const payload = {
      address: addressLine1 + addressLine2,
        addressLine1: addressLine1,
        addressLine2: addressLine2,
      countryCode: countryCode,
        country:countryInfo,
      zip: pincodeInfo,
      state: stateInfo,
      district: districtInfo,
      email: emailInfo,
      mobile: mobileInfo,
      name: name,
      defaultAddress: defaultAddress,
      cartContext: cartContext,
      customerId: customerId,
      token: token
    };


    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: token,
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (response.ok) {
          setLoading(false)
          if( result.token)
          {localStorage.setItem("token", result.token);}
          localStorage.setItem("customerId", result.userId);
          localStorage.setItem("usermob", result.mobile)
        // alert("Address added successfully!");
        toast.success("Address added successfully!");
        setRefreshAddresses((prev) => !prev);

        clearForm();
        closeModal();

      } else {
          setLoading(false)
        console.error("Error add addressing:", result);
      }
    } catch (error) {
        setLoading(false)
      console.error("Error:", error);
    }
  };

  const clearForm = () => {
    setName("");
    setAddressLine1("");
    setAddressLine2("");
    setPincodeInfo("");
    setCountryCode("");
    setCountryInfo("");
    setStateInfo("");
    setDistrictInfo("");
    setEmailInfo("");
    setMobileInfo("");
  };

  const closeModal = () => {
    clearForm();

    const modalElement = document.getElementById("addressModal");
    if (modalElement) {
      modalElement.classList.remove("show"); 
      modalElement.setAttribute("aria-hidden", "true");
      modalElement.style.display = "none";
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "";
      document.body.style.paddingRight = ""; 
      const backdrop = document.querySelector(".modal-backdrop");
      if (backdrop) backdrop.remove();
    }
  };

  return (
    <div
      className="modal fade"
      id="addressModal"
      tabIndex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
        {loading && <Loader/>}
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content" style={{ borderRadius: "20px" }}>
            <div className="address-heading">
                <div className="address">.</div>
                <h1 className="title">ADD ADDRESS</h1>
                <button className="close-button" data-bs-dismiss="modal"><i className="fa-solid fa-xmark"></i></button>
            </div>
          <div className="modal-body">
              <div className="address-container">
                  <h2 className="subtitle">Enter a new delivery address</h2>
              </div>
            {/* form start */}
              <form>
                <div className={"addressFieldGroup"}
                >
                <label
                className="addressFormLabel"
                htmlFor="name">
                  Name
                </label>
                <input
                  placeholder="Enter Name"
                  type="text"
                  name="name"
                  id="name"
                  className="addressInput"
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                    if (e.target.value.trim()) setNameError("");
                  }}
                />
                      {nameError && <p style={{fontSize:'12px'}} className="text-danger mb-0 ps-2">{nameError}</p>}
              </div>
              <div className={"addressFieldGroup"}>
                <label htmlFor="email" className={"addressFormLabel"}>Email Address</label>
                <input id="email" type="email"
                  placeholder="Enter email address"
                  value={emailInfo}
                  className="addressInput"
                  onChange={(e) => {
                    setEmailInfo(e.target.value);
                    if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e.target.value))
                      setEmailError("");}}
                />
                {emailError && (
                  <p
                    style={{ fontSize: "12px" }}
                    className="text-danger mb-0 ps-2"
                  >
                    {emailError}
                  </p>
                )}
              </div>
              <div className="input-row">
                <div className="addressFieldGroup">
                  <label htmlFor="country-code" className={"addressFormLabel"}>Country Code</label>
                          <select id="country-code"  className="addressInput" value={countryCode} onChange={(e) => setCountryCode(e.target.value)}>
                    <option value={""}>select</option>
                    {countryCodeMapping.map((mapping) => {
                      return (
                        <option key={mapping.code} value={mapping.code}>{mapping.value}</option>
                      );
                    })}
                  </select>
                  {countryCodeError && (
                    <p
                      style={{ fontSize: "12px" }}
                      className="text-danger mb-0 ps-2"
                    >
                      {countryCodeError}
                    </p>
                  )}
                </div>

                <div className={"addressFieldGroup"}>
                  <label htmlFor="mobile" className={"addressFormLabel"}>Mobile No</label>
                  <input id="mobile" type="text"
                    className="addressInput"
                    placeholder="Enter mobile no."
                    value={mobileInfo}
                    maxLength={10}
                    onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d{0,10}$/.test(value)) {
                    setMobileInfo(value);
                    if (value.length === 10) {
                       setMobileError("");
                      } 
                    }
                    }}
                  />
                  {mobileError && (
                    <p
                      style={{ fontSize: "12px" }}
                      className="text-danger mb-0 ps-2"
                    >
                      {mobileError}
                    </p>
                  )}
                </div>
              </div>
              <div className="addressFieldGroup">
                <label htmlFor="pin-code" className="addressFormLabel">PIN Code</label>
                <input id="pin-code" type="text"
                  placeholder="Enter PIN Code"
                  className="addressInput"
                  value={pincodeInfo}
                  maxLength={6}
                  onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d{0,6}$/.test(value)) {
                  setPincodeInfo(value);
                  }
                  }}
                />
                {pincodeError && (
                  <p
                    style={{ fontSize: "12px" }}
                    className="text-danger mb-0 ps-2"
                  >
                    {pincodeError}
                  </p>
                )}
              </div>

              <div className={"addressFieldGroup"}>
                <label htmlFor="district" className={"addressFormLabel"}>District</label>
                <input id="district" type="text"
                  placeholder="Enter District"
                  className="addressInput"
                  value={districtInfo}
                  disabled
                />
                {districtError && (
                  <p
                    style={{ fontSize: "12px" }}
                    className="text-danger mb-0 ps-2"
                  >
                    {districtError}
                  </p>
                )}
              </div>
              <div className={"addressFieldGroup"}>
                <label htmlFor="address-line-1" className={"addressFormLabel"}>Address Line 1</label>
                <input
                  id="address-line-1"
                  type="text"
                  placeholder="Enter Address Line 1"
                  className="addressInput"
                  value={addressLine1}
                  onChange={(e) => {
                    setAddressLine1(e.target.value);
                    if (e.target.value.trim()) setAddressLine1Error("");
                  }}
                />
                {addressLine1Error && (
                  <p
                    style={{ fontSize: "12px" }}
                    className="text-danger mb-0 ps-2"
                  >
                    {addressLine1Error}
                  </p>
                )}
              </div>

              <div className={"addressFieldGroup"}>
                <label htmlFor="address-line-1" className={"addressFormLabel"}>Address Line 2</label>
                <input
                  id="address-line-2"
                  type="text"
                  placeholder="Enter Address Line 2"
                  className="addressInput"
                  value={addressLine2}
                  onChange={(e) => {
                    setAddressLine2(e.target.value);
                    if (e.target.value.trim()) setAddressLine2Error("");
                  }}
                />
                {addressLine2Error && (
                  <p
                    style={{ fontSize: "12px" }}
                    className="text-danger mb-0 ps-2"
                  >
                    {addressLine2Error}
                  </p>
                )}
              </div>

              <div className="input-row">
                <div className={"addressFieldGroup"}>
                  <label htmlFor="state" className={"addressFormLabel"}>
                    State
                  </label>
                  <input
                    id="state"
                    type="text"
                    placeholder="Enter State"
                    className="addressInput"
                    value={stateInfo}
                    disabled
                  />
                  {stateError && (
                    <p
                      style={{ fontSize: "12px" }}
                      className="text-danger mb-0 ps-2"
                    >
                      {stateError}
                    </p>
                  )}
                </div>
                <div className={"addressFieldGroup"}>
                  <label htmlFor="country" className={"addressFormLabel"}>Country</label>
                  <select id="country"
                    value={countryInfo}
                    className="addressInput"
                    onChange={(e) => {
                      setCountryInfo(e.target.value);
                      if (e.target.value.trim()) setCountryError("");
                    }}>
                    <option value={""}>select</option>
                    {countryMapping.map((mapping) => {
                      return (
                        <option key={mapping.code} value={mapping.code}>{mapping.value}</option>
                      );
                    })}
                  </select>
                  {countryError && (
                    <p
                                  style={{ fontSize: "12px" }}
                                  className="text-danger mb-0 ps-2"
                              >
                                  {countryError}
                              </p>
                          )}
                      </div>
                  </div>

                  <div className="checkbox-group">
                      <input type="checkbox" id="default-address" onChange={() => setDefaultAddress(prev => !prev)} checked={defaultAddress}/>
                      <label htmlFor="default-address">Make this as default address</label>
                  </div>

                  <button type="button" className="submit-button" onClick={handleSubmit}>
                      Add & Use this Address
                  </button>
              </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddressModal;
